import React, {useEffect } from 'react';  
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const FeeStructure = () => {
    useEffect(() => {
        document.title = 'Fee Structure -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                 <li>   Academics</li>  
                 <li> Fee Structure</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Fee Structure</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="table-responsive maintable">
                            <table className="table">
                            <thead> <tr> <th rowspan="2"> Particulars </th> <th colspan="3"> KG - V </th> <th colspan="3"> VI - X </th> <th colspan="3"> XI - XII<br/> Computer Stream </th> <th colspan="3"> XI - XII<br/> ( Non computer Stream ) </th> 
                            </tr>
                             </thead>
                              <tbody>
                               <tr> <td></td><td> AFA </td> <td> AFO </td> <td> NAF </td> <td> AFA </td> <td> AFO </td> <td> NAF </td> <td> AFA </td> <td> AFO </td> <td> NAF </td> <td> AFA </td> <td> AFO </td> <td> NAF </td> 
                            </tr>
                             <tr> <td> Tuition Fee<br/> ( Per Month) </td> <td> 4680 </td> <td> 6160 </td> <td> 8060 </td> <td> 5480 </td> <td> 7450 </td> <td> 9310 </td> <td> 6440 </td> <td> 8770 </td> <td> 11080 </td> <td> 6170 </td> <td> 8510 </td> <td> 10740 </td> 
                            </tr>
                             <tr> <td> Annual Fee </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> <td> 4450 </td> 
                            </tr>
                             <tr> <td> Development Fee </td> <td> 5000 </td> <td> 5000 </td> <td> 5000 </td> <td> 5700 </td> <td> 5700 </td> <td> 5700 </td> <td> 6800 </td> <td> 6800 </td> <td> 6800 </td> <td> 6800 </td> <td> 6800 </td> <td> 6800 </td> 
                            </tr>
                             <tr> <td> P T A Charges </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> <td> 250 </td> 
                            </tr>
                             <tr> <td> Bus Fee </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> <td> 3500 </td> 
                            </tr>
                             <tr> <td> Admission Fee<br/> ( New Admission) </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> <td> 200 </td> 
                            </tr>
                             <tr> <td> Registration Fee<br/> ( New Admission) </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> <td> 25 </td> 
                            </tr>
                             </tbody>
                             </table>
                            </div>
                        </div> 
                        <h6>HOSTEL FEE YEAR 2025-26</h6>
                        <div className="col-lg-12">
                        <div className="table-responsive maintable">
                            <table className="table">
                            <thead>  
                                <tr> <th> HOSTEL FEE </th> <th> AFA </th> <th> AFO </th> <th> NAF </th> <th>REMARK</th> <th>Chargable</th> </tr>
                            </thead>
                            <tbody>
                                    <tr> <td>   Messing Fee </td> <td> 6400 </td> <td> 6400 </td> <td> 6400 </td>  <td>Per Month</td> <td>Qtrly</td></tr>
                                    <tr> <td>   Allied  Charges  </td> <td> 3830 </td> <td> 4310 </td> <td> 7100 </td> <td>Per Month</td>  <td>Half yeary</td></tr>
                                    <tr> <td>   Regn / Prospectus  </td> <td> 1100 </td> <td> 1100 </td> <td> 1100 </td><td>New Admission</td> <td>one time</td> </tr>
                                    <tr> <td> SECURITY (Refundable)   </td> <td> 3830 </td> <td> 4310 </td> <td> 7100 </td><td>New Admission</td><td>one time</td> </tr>
                            </tbody>
                            </table>
                            </div>
                        </div> 
                        <p>NOTE : Tuition Fee is to be deposited on Quarterly Basis</p> 
                        <p> <b>* </b>  In order to reduce the number of fee heads, Computer fee has bee merged with Tuition Fee wef 01 April 2023. Only Tuition Fee component has been increased by 10% and no increase has been made in Computer Fee. </p> 
                        <p> <b>* </b> In order to reduce the number of annual chargers heads, All one time charges have been merged with Annual charges. No increase has been made in Annual and other one time charges. </p> 
                        <p> <b>* </b>  Fee may be paid either by SBI e-Pay system through School Website https://www.tafssp.com after entering ward login and accessing fee portal </p>
                       </div>
            </div>
        </div>
     </>
  )
}

export default FeeStructure